<template>
  <UDashboardPanel id="dashboard" :ui="{ body: 'h-full sm:p-0 p-0' }">
    <!--
    <template #header>
      <UDashboardNavbar :title="t('navigation.dashboard')">
        <template #leading>
          <UDashboardSidebarCollapse />
        </template>
        <template #right>
          <LanguageSwitcher />
        </template>
      </UDashboardNavbar>
    </template>
    -->
    
    <template #body>
      <div class="px-4 pt-4 sm:px-4 lg:px-4 h-full flex flex-col">
        <div class="w-full flex-1 flex flex-col min-h-0">
          <!--
          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
            <UCard>
              <div class="flex items-center gap-4">
                <UIcon name="i-heroicons-inbox-stack" class="w-8 h-8 text-primary-500"/>
                <div>
                  <p class="text-sm text-gray-500 dark:text-gray-400">New Orders</p>
                  <p class="text-2xl font-bold">12</p>
                </div>
              </div>
            </UCard>
            <UCard>
              <div class="flex items-center gap-4">
                <UIcon name="i-heroicons-clock" class="w-8 h-8 text-yellow-500"/>
                <div>
                  <p class="text-sm text-gray-500 dark:text-gray-400">Pending Approval</p>
                  <p class="text-2xl font-bold">5</p>
                </div>
              </div>
            </UCard>
            <UCard>
              <div class="flex items-center gap-4">
                <UIcon name="i-mdi-check-circle" class="w-8 h-8 text-green-500"/>
                <div>
                  <p class="text-sm text-gray-500 dark:text-gray-400">Completed This Week</p>
                  <p class="text-2xl font-bold">28</p>
                </div>
              </div>
            </UCard>
            <UCard>
              <div class="flex items-center gap-4">
                <UIcon name="i-heroicons-exclamation-triangle" class="w-8 h-8 text-red-500"/>
                <div>
                  <p class="text-sm text-gray-500 dark:text-gray-400">Issues Reported</p>
                  <p class="text-2xl font-bold">2</p>
                </div>
              </div>
            </UCard>
          </div>
          -->
          
          <div class="grid grid-cols-1 lg:grid-cols-2 gap-5 flex-1 min-h-0">
            <div class="lg:col-span-2 flex flex-col min-h-0">
              <div v-if="status === 'pending' || data.length > 0 || hasActiveDashboardFilters" class="mb-4 space-y-3">
                <div class="flex flex-wrap items-center justify-between gap-3">
                  <div class="flex items-center gap-2 flex-1 min-w-[16rem]">
                    <UInput v-model="searchQuery" :placeholder="t('dashboard.searchPlaceholder')" icon="i-heroicons-magnifying-glass" class="w-full md:w-80" :ui="{ trailing: 'pe-1' }">
                      <template v-if="searchQuery?.length" #trailing>
                        <UButton
                          color="neutral"
                          variant="link"
                          size="sm"
                          icon="i-lucide-circle-x"
                          :aria-label="t('workflows.table.filters.clear')"
                          @click="onClearSearch"
                        />
                      </template>
                    </UInput>
                  </div>
                  <UButton :to="{ path: '/workflows' }"  variant="subtle" color="primary" icon="i-heroicons-arrow-right-circle">{{ t('dashboard.requiringAction.viewAll') }}</UButton>
                </div>
              </div>
              
              <div v-if="status === 'pending'" class="flex-1 min-h-0">
                <div class="overflow-x-auto overflow-y-hidden pb-2 h-full">
                  <div class="flex gap-4 snap-x snap-mandatory h-full">
                    <div v-for="(statusName, idx) in skeletonStatuses" :key="'sk-col-' + statusName" :id="'sk-col-' + statusName" class="snap-start shrink-0 min-h-0 w-[22rem] md:w-[26rem] xl:w-[28rem]">
                      <div class="h-full overflow-y-auto overscroll-y-contain flex flex-col pr-1">
                        <div class="bg-(--ui-bg-muted) sticky top-0 z-20 backdrop-blur-sm rounded-lg px-3 py-2 flex items-center justify-between">
                          <div class="flex items-center gap-2">
                            <div class="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 bg-(--ui-bg-elevated)">
                              <USkeleton class="h-5 w-5" />
                            </div>
                            <USkeleton class="h-4 w-32" />
                          </div>
                          <USkeleton class="h-5 w-10 rounded-full" />
                        </div>
                        
                        <div class="p-3 space-y-3">
                          <div v-for="j in 1" :key="'sk-step-' + idx + '-' + j" class="space-y-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-(--ui-bg-muted) shadow-sm">
                            <div class="flex items-center justify-between px-3 py-2">
                              <div class="flex items-center gap-2">
                                <UIcon name="i-heroicons-bars-3-bottom-left" class="text-gray-300" />
                                <USkeleton class="h-3 w-24" />
                                <USkeleton class="h-3 w-8" />
                              </div>
                              <USkeleton class="h-4 w-4 rounded-md" />
                            </div>

                            <div class="px-3 pb-3">
                              <div class="grid grid-cols-1 gap-3">
                                <UCard v-for="k in 3" :key="'sk-card-' + idx + '-' + j + '-' + k" :ui="{ root: 'divide-none shadow-sm', body: 'p-3 sm:px-4 sm:pt-4 sm:pb-1' }" class="bg-(--ui-bg)">
                                  <div class="flex items-start gap-4">
                                    <div class="flex-1 space-y-3">
                                      <div class="flex justify-between items-center">
                                        <div class="flex items-center gap-2">
                                          <USkeleton class="h-6 w-32 rounded-full" />
                                        </div>
                                        <div class="flex items-center gap-2">
                                          <USkeleton class="h-5 w-24 rounded-full" />
                                          <USkeleton class="h-8 w-8 rounded-md" />
                                        </div>
                                      </div>
                                      
                                      <div class="flex justify-between items-center mb-2 mt-2">
                                        <USkeleton class="h-4 w-40" />
                                        <USkeleton class="h-3 w-20" />
                                      </div>

                                      <div class="grid grid-cols-2 gap-3 mt-2">
                                        <USkeleton class="h-12 w-full rounded-lg" />
                                        <USkeleton class="h-12 w-full rounded-lg" />
                                      </div>
                                    </div>
                                  </div>
                                </UCard>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div v-else-if="data.length > 0" class="flex-1 min-h-0">
                <div class="overflow-x-auto overflow-y-hidden pb-0 h-full">
                  <div class="flex gap-4 snap-x snap-mandatory h-full">
                    <div v-for="status in visibleStatuses" :key="status" :id="'col-' + status" class="snap-start shrink-0 min-h-0 w-[22rem] md:w-[26rem] xl:w-[28rem]">
                      <div class="h-full overflow-y-auto overscroll-y-contain flex flex-col pr-1">
                        <div :class="getStatusConfig(status).bgColor" class="sticky top-0 z-20 backdrop-blur-sm rounded-lg px-3 py-2 flex items-center justify-between">
                          <div class="flex items-center gap-2">
                            <div class="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0" :class="getStatusConfig(status).bgColor">
                              <UIcon :name="getStatusConfig(status).icon" :class="getStatusConfig(status).textColor" class="w-5 h-5" />
                            </div>
                            <div class="min-w-0">
                              <h3 class="text-sm font-semibold text-gray-800 dark:text-gray-100 flex items-center gap-2">
                                {{ getStatusConfig(status).label }}
                              </h3>
                            </div>
                          </div>
                          <UBadge color="neutral" variant="subtle" class="rounded-full">
                            {{ statusTotalCount(status) }}
                          </UBadge>
                        </div>
                        
                        <div class="p-3 space-y-3">
                          <div v-for="step in stepsWithItems(status)" :key="status + '-' + step" class="space-y-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-(--ui-bg-muted) shadow-sm">
                            <div class="flex items-center justify-between px-3 py-2 cursor-pointer select-none" role="button" :aria-expanded="!isStepCollapsed(status, step)" @click="toggleStep(status, step)">
                              <div class="flex items-center gap-2">
                                <UIcon name="i-heroicons-bars-3-bottom-left" class="text-gray-400" />
                                <UBadge size="sm" variant="ghost"color="neutral" class="rounded-full px-2.5 py-1 text-[12px] leading-none font-semibold">
                                  {{ t('processStatus.step.' + status.charAt(0).toLowerCase() + status.slice(1) + '.' + step.charAt(0).toLowerCase() + step.slice(1)) }}
                                  <!--<span class="ml-1 opacity-70">({{ (groupedByStatusAndStep[status] && groupedByStatusAndStep[status][step] ? groupedByStatusAndStep[status][step].length : 0) }})</span>-->
                                </UBadge>
                              </div>
                              <UButton size="xs" variant="ghost" color="neutral" :icon="isStepCollapsed(status, step) ? 'i-heroicons-chevron-down' : 'i-heroicons-chevron-up'" class="p-0" @click.stop="toggleStep(status, step)"/>
                            </div>
                            
                            <div v-show="!isStepCollapsed(status, step)" class="px-3 pb-3">
                              <div v-if="groupedByStatusAndStep[status] && groupedByStatusAndStep[status][step] && groupedByStatusAndStep[status][step].length" class="grid grid-cols-1 gap-3">
                                <UCard v-for="workflow in groupedByStatusAndStep[status][step]" :key="workflow.externalReference" :ui="{ root: 'divide-none shadow-sm', body: 'p-3 sm:px-4 sm:pt-4 sm:pb-1' }" @click="!hasMultiplePurchaseOrders(workflow) && showDetails(workflow)" :class="['bg-(--ui-bg) transition-all duration-100', hasMultiplePurchaseOrders(workflow) ? '' : 'hover:ring-2 hover:ring-primary-500 dark:hover:ring-primary-400 cursor-pointer']">
                                  <div class="flex flex-col gap-3">
                                    <div>
                                      <div class="flex justify-between items-center mb-2.5">
                                        <div :class="[WorkflowStatus.QuotationApproval, WorkflowStatus.QuotationRejected].includes(workflow.status) ? 'bg-blue-50 dark:bg-blue-900/30 ring-1 ring-blue-200 dark:ring-blue-800' : 'bg-primary-50 dark:bg-primary-900/30 ring-1 ring-primary-200 dark:ring-primary-800'" class="px-3 py-1 rounded-full flex items-center gap-2">
                                          <UIcon :name="[WorkflowStatus.QuotationApproval, WorkflowStatus.QuotationRejected].includes(workflow.status) ? 'i-lucide-circle-dollar-sign' : 'i-heroicons-clipboard-document-list'" :class="[WorkflowStatus.QuotationApproval, WorkflowStatus.QuotationRejected].includes(workflow.status) ? 'w-4 h-4 text-blue-600 dark:text-blue-400' : 'w-4 h-4 text-primary-600 dark:text-primary-400'" />
                                          <span :class="[WorkflowStatus.QuotationApproval, WorkflowStatus.QuotationRejected].includes(workflow.status) ? 'text-blue-600 dark:text-blue-400' : 'text-primary-600 dark:text-primary-400'" class="text-xs font-mono font-semibold">{{ workflow?.externalReference || '' }}</span>
                                        </div>
                                        <div v-if="!hasMultiplePurchaseOrders(workflow) && workflow.purchaseOrders?.length === 1" class="flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-semibold" :class="isVehicleOrderType((workflow.purchaseOrders.find(po => isVehicleOrderType(po.type)) || workflow.purchaseOrders[0])?.type) ? 'bg-indigo-100 dark:bg-indigo-900/30 text-indigo-600 dark:text-indigo-400 ring-1 ring-indigo-200 dark:ring-indigo-800' : 'bg-amber-100 dark:bg-amber-900/30 text-amber-600 dark:text-amber-400 ring-1 ring-amber-200 dark:ring-amber-800'">
                                          <UIcon :name="isVehicleOrderType((workflow.purchaseOrders.find(po => isVehicleOrderType(po.type)) || workflow.purchaseOrders[0])?.type) ? 'i-mdi-car-hatchback' : 'i-mdi-tire'" class="w-3.5 h-3.5" />
                                          <span>{{ isVehicleOrderType((workflow.purchaseOrders.find(po => isVehicleOrderType(po.type)) || workflow.purchaseOrders[0])?.type) ? t('workflowDetail.purchaseOrderType.vehicle') : t('workflowDetail.purchaseOrderType.tyre') }}</span>
                                        </div>
                                      </div>
                                      <div class="text-sm font-semibold text-gray-700 dark:text-gray-300 pl-1">
                                        <template v-if="workflow.tenant === Tenant.FI">{{ workflow.manufacturer }} {{ getSapLocalizedText(workflow.modelDescription, locale) !== '-' ? getSapLocalizedText(workflow.modelDescription, locale) : [workflow.model, workflow.modelTrim].filter(Boolean).join(' ') }}</template>
                                        <template v-else>{{ workflow.manufacturer }} {{ workflow.model }} {{ workflow.modelTrim }}</template>
                                      </div>
                                      <div v-if="workflow.description" class="mt-1.5 pl-1">
                                        <span class="text-xs text-gray-500 dark:text-gray-400 truncate block" :title="workflow.description">{{ workflow.description }}</span>
                                      </div>
                                    </div>
                                    
                                    <div v-if="hasMultiplePurchaseOrders(workflow)" class="flex flex-col gap-2">
                                      <div class="grid grid-cols-2 gap-3">
                                        <div class="flex items-center gap-2 p-2 bg-(--ui-bg-muted) rounded-lg border border-gray-100 dark:border-gray-700/50">
                                          <div class="w-7 h-7 bg-purple-200 dark:bg-purple-900/30 rounded-md flex items-center justify-center shrink-0">
                                            <UIcon name="i-heroicons-user" class="w-4 h-4 text-purple-600 dark:text-purple-400" />
                                          </div>
                                          <div class="min-w-0 flex-1">
                                            <p class="text-xs font-medium text-gray-500 dark:text-gray-400">{{ t('dashboard.requiringAction.client') }}</p>
                                            <p class="text-xs font-semibold text-gray-700 dark:text-gray-300 truncate">{{ workflow.client?.name || '-' }}</p>
                                          </div>
                                        </div>
                                        <div class="flex items-center gap-2 p-2 bg-(--ui-bg-muted) rounded-lg border border-gray-100 dark:border-gray-700/50">
                                          <div class="w-7 h-7 bg-green-200 dark:bg-green-900/30 rounded-md flex items-center justify-center shrink-0">
                                            <UIcon name="i-heroicons-building-storefront" class="w-4 h-4 text-green-600 dark:text-green-400" />
                                          </div>
                                          <div class="min-w-0 flex-1">
                                            <p class="text-xs font-medium text-gray-500 dark:text-gray-400">{{ t('dashboard.requiringAction.supplier') }}</p>
                                            <div class="flex flex-col items-start">
                                              <p v-if="workflow.hasMultipleSuppliers" class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-300 ring-1 ring-yellow-300 dark:ring-yellow-700 w-fit mt-1 whitespace-nowrap">{{ t('workflows.table.multipleSuppliers') }}</p>
                                              <p v-else class="text-xs font-semibold text-gray-700 dark:text-gray-300 truncate">{{ workflow.supplier?.name || '-' }}</p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      
                                      <div class="space-y-1.5 mt-0.5 pb-1">
                                        <div v-for="po in workflow.purchaseOrders" :key="po.type" @click.stop="showDetails(workflow, po.type)" class="group flex items-center justify-between p-3 rounded-md bg-(--ui-bg) shadow-sm ring-1 ring-gray-200 dark:ring-gray-700 hover:shadow-md hover:ring-primary-500 dark:hover:ring-primary-400 cursor-pointer transition-all duration-200 border-l-4" :class="isVehicleOrderType(po.type) ? 'border-l-indigo-500' : 'border-l-amber-500'">
                                          <div class="flex items-center gap-3 min-w-0">
                                            <div :class="isVehicleOrderType(po.type) ? 'bg-indigo-100 dark:bg-indigo-900/30 text-indigo-600 ring-1 ring-indigo-200 dark:ring-indigo-800' : 'bg-amber-100 dark:bg-amber-900/30 text-amber-600 ring-1 ring-amber-200 dark:ring-amber-800'" class="w-8 h-8 rounded-lg flex items-center justify-center shrink-0">
                                              <UIcon :name="isVehicleOrderType(po.type) ? 'i-mdi-car-hatchback' : 'i-mdi-tire'" class="w-5 h-5" />
                                            </div>
                                            <div class="flex flex-col min-w-0">
                                              <span class="text-xs font-bold text-gray-900 dark:text-gray-100 leading-tight">{{ isVehicleOrderType(po.type) ? t('workflowDetail.purchaseOrderType.vehicle') : t('workflowDetail.purchaseOrderType.tyre') }}</span>
                                              <div v-if="po.supplier?.name" class="flex items-center gap-1 mt-0.5 text-gray-500 dark:text-gray-400">
                                                <UIcon name="i-heroicons-building-storefront" class="w-3 h-3 text-gray-400" />
                                                <span class="text-[11px] truncate font-medium leading-none">{{ po.supplier.name }}</span>
                                              </div>
                                              <span v-else class="text-[10px] text-gray-400 mt-0.5">-</span>
                                            </div>
                                          </div>
                                          <div class="pl-2">
                                            <UIcon name="i-heroicons-arrow-right-circle" class="w-5 h-5 text-gray-300 group-hover:text-primary-600 transition-colors" />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    
                                    <div v-else class="grid grid-cols-2 gap-3">
                                      <div class="flex items-center gap-2 p-2.5 bg-(--ui-bg-elevated)/50 rounded-lg">
                                        <div class="w-7 h-7 bg-purple-200 dark:bg-purple-900/30 rounded-lg flex items-center justify-center">
                                          <UIcon name="i-heroicons-user" class="w-4 h-4 text-purple-600 dark:text-purple-400"/>
                                        </div>
                                        <div class="min-w-0 flex-1">
                                          <p class="text-xs font-medium text-gray-500 dark:text-gray-400">{{ t('dashboard.requiringAction.client') }}</p>
                                          <p class="text-xs font-semibold text-gray-900 dark:text-white truncate">{{ workflow.client?.name || '-' }}</p>
                                        </div>
                                      </div>
                                      <div class="flex items-center gap-2 p-2.5 bg-(--ui-bg-elevated)/50 rounded-lg">
                                        <div class="w-7 h-7 bg-green-200 dark:bg-green-900/30 rounded-lg flex items-center justify-center">
                                          <UIcon name="i-heroicons-building-storefront" class="w-4 h-4 text-green-600 dark:text-green-400"/>
                                        </div>
                                        <div class="min-w-0 flex-1">
                                          <p class="text-xs font-medium text-gray-500 dark:text-gray-400">{{ t('dashboard.requiringAction.supplier') }}</p>
                                          <p class="text-xs font-semibold text-gray-900 dark:text-white truncate">{{ workflow.supplier?.name || '-' }}</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </UCard>
                              </div>
                              <div v-else class="px-2 py-3 text-xs text-gray-500 dark:text-gray-400 flex items-center gap-2">
                                <UIcon name="i-heroicons-inbox" class="text-gray-300" />
                                <span>{{ t('common.empty') || 'No items in this step' }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div v-else class="flex-1 min-h-0 flex items-center justify-center">
                <div class="flex flex-col items-center gap-8 animate-[fadeIn_0.5s_ease-out]">
                  <div class="flex flex-col items-center text-center max-w-sm">
                    <div class="w-12 h-12 rounded-xl bg-primary-50 dark:bg-primary-900/20 flex items-center justify-center mb-4">
                      <UIcon name="i-mdi-check-all" class="w-6 h-6 text-primary-500 dark:text-primary-400" />
                    </div>
                    <h3 class="text-base font-semibold text-(--ui-text)">{{ t('dashboard.empty.title') }}</h3>
                    <p class="text-sm text-(--ui-text-muted) mt-1.5 leading-relaxed">{{ t('dashboard.empty.description') }}</p>
                    <UButton :to="{ path: '/workflows' }" variant="subtle" color="primary" icon="i-heroicons-arrow-right-circle" class="mt-5">
                      {{ t('dashboard.empty.viewAll') }}
                    </UButton>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </UDashboardPanel>

  <WorkflowDetailModal
    v-if="isModalOpen && selectedExternalReference"
    v-model="isModalOpen"
    :external-reference="selectedExternalReference"
    :purchase-order-type="selectedPurchaseOrderType"
    @closeModal="closeModal"
  />
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted, watch, computed } from 'vue'
import { useWorkflowsData } from "@/composables/useWorkflowsData.js";
import { QuotationStepKeys, VehicleOrderStepKeys, DeliveryStepKeys, TyreOrderStepKeys, WorkflowStatus } from '@/api/eOrdersApi'
import { useRoute, useRouter } from "vue-router";
import { useWorkflowEdit } from "@/store/workflowEdit.ts";
import { useI18n } from "vue-i18n";
import { PurchaseOrder, isVehicleOrderType } from "@/types/enums/PurchaseOrder.ts";
import { Tenant } from "@/types/enums/Tenant.ts";
import { getSapLocalizedText } from "@/utils/sapLocalization";
import WorkflowDetailModal from "@/components/workflows/WorkflowDetailModal.vue";

const { t, locale } = useI18n()
const route = useRoute()
const router = useRouter()
const workflowEditStore = useWorkflowEdit();

const { data, status, fetchWorkflows, applyFilters, currentFilters } = useWorkflowsData()

const isModalOpen = ref(false)
const selectedExternalReference = ref<string | null>(null)
const selectedPurchaseOrderType = ref<string | undefined>(undefined)

const searchQuery = ref('')
let searchDebounce: any = null

const statusSequence: WorkflowStatus[] = [
  WorkflowStatus.QuotationApproval,
  WorkflowStatus.QuotationRejected,
  WorkflowStatus.OrderApproval,
  WorkflowStatus.OrderRejected,
  WorkflowStatus.OrderProcessing,
  WorkflowStatus.OrderUpdated,
  WorkflowStatus.Delivery,
  WorkflowStatus.Completed,
  WorkflowStatus.Archived,
]

const stepOrderMap: Partial<Record<WorkflowStatus, string[]>> = {
  [WorkflowStatus.QuotationApproval]: QuotationStepKeys,
  [WorkflowStatus.QuotationRejected]: QuotationStepKeys,
  [WorkflowStatus.OrderApproval]: [...VehicleOrderStepKeys, ...TyreOrderStepKeys],
  [WorkflowStatus.OrderRejected]: [...VehicleOrderStepKeys, ...TyreOrderStepKeys],
  [WorkflowStatus.OrderProcessing]: [...DeliveryStepKeys, ...TyreOrderStepKeys],
  [WorkflowStatus.OrderUpdated]: [...DeliveryStepKeys, ...TyreOrderStepKeys],
  [WorkflowStatus.Delivery]: [...DeliveryStepKeys, ...TyreOrderStepKeys],
  [WorkflowStatus.Completed]: [...DeliveryStepKeys, ...TyreOrderStepKeys],
  [WorkflowStatus.Archived]: [...DeliveryStepKeys, ...TyreOrderStepKeys],
  [WorkflowStatus.NotDefined]: [],
}

const getStatusConfig = (statusLabel: string) => {
  const statusConfig = {
    [WorkflowStatus.QuotationApproval]: { bgColor: 'bg-orange-100 dark:bg-orange-900/30', textColor: 'text-orange-600 dark:text-orange-400', icon: 'i-mdi-file-document-edit', label: t('processStatus.status.quotationApproval') },
    [WorkflowStatus.OrderApproval]: { bgColor: 'bg-blue-100 dark:bg-blue-900/30', textColor: 'text-blue-600 dark:text-blue-400', icon: 'i-mdi-file-check', label: t('processStatus.status.orderApproval') },
    [WorkflowStatus.OrderProcessing]: { bgColor: 'bg-purple-100 dark:bg-purple-900/30', textColor: 'text-purple-600 dark:text-purple-400', icon: 'i-mdi-cog-transfer', label: t('processStatus.status.orderProcessing') },
    [WorkflowStatus.OrderUpdated]: { bgColor: 'bg-purple-100 dark:bg-purple-900/30', textColor: 'text-purple-600 dark:text-purple-400', icon: 'i-mdi-cog-transfer', label: t('processStatus.status.orderUpdated') },
    [WorkflowStatus.Delivery]: { bgColor: 'bg-orange-100 dark:bg-orange-900/30', textColor: 'text-orange-600 dark:text-orange-400', icon: 'i-mdi-truck-delivery', label: t('processStatus.status.delivery') },
    [WorkflowStatus.QuotationRejected]: { bgColor: 'bg-red-100 dark:bg-red-900/30', textColor: 'text-red-600 dark:text-red-400', icon: 'i-mdi-close-circle', label: t('processStatus.status.quotationRejected') },
    [WorkflowStatus.OrderRejected]: { bgColor: 'bg-red-100 dark:bg-red-900/30', textColor: 'text-red-600 dark:text-red-400', icon: 'i-mdi-close-circle', label: t('processStatus.status.orderRejected') },
    [WorkflowStatus.Completed]: { bgColor: 'bg-green-100 dark:bg-green-900/30', textColor: 'text-green-600 dark:text-green-400', icon: 'i-mdi-check-circle', label: t('processStatus.status.completed') },
    [WorkflowStatus.Archived]: { bgColor: 'bg-(--ui-bg-elevated)', textColor: 'text-gray-600 dark:text-gray-400', icon: 'i-mdi-archive', label: t('processStatus.status.archived') }
  }

  return statusConfig[statusLabel as keyof typeof statusConfig]
}

const collapsedSteps = ref<Record<string, boolean>>({})
const collapsedStorageKey = 'dashboard.collapsedSteps'

const stepKey = (status: WorkflowStatus, step: string) => `${status}::${step}`

const isStepCollapsed = (status: WorkflowStatus, step: string) => {
  return !!collapsedSteps.value[stepKey(status, step)]
}

const toggleStep = (status: WorkflowStatus, step: string) => {
  const key = stepKey(status, step)
  
  collapsedSteps.value[key] = !collapsedSteps.value[key]
  
  try {
    localStorage.setItem(collapsedStorageKey, JSON.stringify(collapsedSteps.value))
  } catch {
    
  }
}

const hasMultiplePurchaseOrders = (workflow: any): boolean => {
  return workflow?.purchaseOrders?.length > 1
}

const hasActiveDashboardFilters = computed(() => searchQuery.value.trim().length > 0)

const groupedByStatusAndStep = computed(() => {
  const groups: Record<string, Record<string, any[]>> = {}
  
  for (const workflow of data.value) {
    const status = workflow.status || WorkflowStatus.NotDefined
    const step = (workflow.step as string) || 'NotDefined'
    
    if (!groups[status]) groups[status] = {}
    if (!groups[status][step]) groups[status][step] = []
    
    groups[status][step].push(workflow)
  }
  
  const sortFn = (a: any, b: any) => {
    const aKey = a.createdAtRaw ? new Date(a.createdAtRaw).getTime() : 0
    const bKey = b.createdAtRaw ? new Date(b.createdAtRaw).getTime() : 0
    
    return bKey - aKey
  }
  
  Object.keys(groups).forEach(st => {
    Object.keys(groups[st]).forEach(step => {
      groups[st][step] = groups[st][step].slice().sort(sortFn)
    })
  })
  
  return groups
})

const visibleStatuses = computed(() => statusSequence.filter(s => groupedByStatusAndStep.value[s] && Object.values(groupedByStatusAndStep.value[s]).some(arr => arr.length > 0)))

const stepsWithItems = (status: WorkflowStatus) => {
  const steps = stepOrderMap[status] || []
  const groups = groupedByStatusAndStep.value[status as unknown as string] || {}
  
  return steps.filter(step => Array.isArray(groups[step]) && groups[step].length > 0)
}

const skeletonStatuses = computed(() => statusSequence.slice(0, Math.min(3, statusSequence.length)))

const statusTotalCount = (status: WorkflowStatus) => {
  const groups = groupedByStatusAndStep.value[status as unknown as string]
  
  if (!groups) return 0
  
  return Object.values(groups).reduce((acc: number, arr: any) => acc + (Array.isArray(arr) ? arr.length : 0), 0)
}

const showDetails = (workflow, poType?: string) => {
  const vehicleOrder = workflow?.purchaseOrders?.find(po => isVehicleOrderType(po.type));
  const resolvedType = poType ?? vehicleOrder?.type ?? workflow?.purchaseOrders?.[0]?.type ?? undefined

  selectedExternalReference.value = workflow.externalReference
  selectedPurchaseOrderType.value = resolvedType
  isModalOpen.value = true

  router.push({
    query: {
      ...route.query,
      modalExternalReference: workflow.externalReference.toString(),
      ...(resolvedType ? { modalType: resolvedType.toString() } : {}),
    },
  })
}

const closeModal = () => {
  setTimeout(async () => {
    isModalOpen.value = false
    selectedExternalReference.value = null
    selectedPurchaseOrderType.value = undefined
    
    workflowEditStore.setEditMode(false);
    workflowEditStore.setEditableWorkflow(null);
    
    const query = {...route.query}
    delete query.modalExternalReference
    delete query.modalType
    delete query.tab
    router.replace({ query })
    
    const filters: any = { assigned: true }
    
    if (searchQuery.value && searchQuery.value.trim().length > 0) {
      filters.search = searchQuery.value.trim()
    }
    
    await fetchWorkflows(500, 1, filters, true)
  }, 100)
}

const onClearSearch = async () => {
  searchQuery.value = ''
  
  await applyToolbarFilters()
}

const applyToolbarFilters = async () => {
  const filters: any = { ...(currentFilters.value || {}) }
  
  filters.assigned = true
  
  if (searchQuery.value && searchQuery.value.trim().length > 0) {
    filters.search = searchQuery.value.trim()
  } else {
    delete filters.search
  }
  
  await applyFilters(filters)
}

onMounted(async () => {
  await fetchWorkflows(500, 1, { assigned: true })
  
  try {
    const raw = localStorage.getItem(collapsedStorageKey)
    
    if (raw) collapsedSteps.value = JSON.parse(raw)
  } catch {
    
  }
  
  const modalExternalReference = route.query.modalExternalReference
  const modalType = route.query.modalType

  if (modalExternalReference) {
    selectedExternalReference.value = modalExternalReference as string
    selectedPurchaseOrderType.value = (modalType as string) || undefined
    isModalOpen.value = true
  }
})

watch(searchQuery, () => {
  if (searchDebounce) clearTimeout(searchDebounce)
  
  searchDebounce = setTimeout(() => {
    applyToolbarFilters()
  }, 400)
})

onUnmounted(() => {
  if (searchDebounce) {
    clearTimeout(searchDebounce)
  }
})
</script>
